exports.onCheckLang = async function (value,lang) {
    var items = [];
    value.filter(item => {
        try {
            var objs = item.title.filter(title => {
                if(title.key == lang){
                    return title
                }
            })[0].value;
            var data = {};
            data.label = objs
            data.value = item._id;
            items.push(data)
        }catch (e) {

        }

    });
    return items;
}

exports.onSetTableSkill = async function (value,lang) {
    return value.filter(item => {
        try {
            item.title = item.title.filter(title => {
                if(title.key == lang){
                    return title
                }
            })[0].value;
            item.description = item.description.filter(title => {
                if(title.key == lang){
                    return title
                }
            })[0].value;
            return item
        }catch (e) {

        }

    });
}

exports.onLabelsLang = async function (value,lang) {
    var items = [];
    value.filter(item => {
        try {
            var objs = item.title.filter(title => {
                if(title.key == lang){
                    return title
                }
            })[0].value;
            items.push(objs)
        }catch (e) {

        }

    });
    return items;
}
